// extracted by mini-css-extract-plugin
module.exports = {"img":"PinIcon_img__QqRRr"};